import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';

export const HideInSidebarCopy: FC = () => <Trans id="hide-in-sidebar-copy">Hide in sidebar</Trans>;
